import {
  Button,
  Container,
  Group,
  Space,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import { Trans } from "react-i18next";
import classes from "./HeroContent.module.css";
import { Link } from "react-scroll";
import { useWizard } from "../BuyWizard/WizardContext";
import { IconWand } from "@tabler/icons-react";

export function HeroContent() {

  const theme = useMantineTheme();
  const wizard = useWizard();
  return (
    <Container className={classes.mainContainer} style={{ maxWidth: theme.breakpoints.lg, width: '100%' }}>
      <div className={classes.content}>
        <Title className={classes.title}>
          <Text
            fs="italic"
            inherit
            variant="gradient"
            gradient={{ from: "#dc3d31", to: "#99180D" }}
          >
            <Trans i18nKey="title.toolkit" />
          </Text>
          <Text component="span" inherit>
            <Trans i18nKey="title.creator" />
          </Text>
        </Title>
        <Text className={classes.description} mt={30}>
          <Trans i18nKey="title.advertisement-text" />
        </Text>
        <Space h={"xl"}/>
        <Group>
          <Link to={"features"}>
            <Button
              variant="default"
              size="lg"
              
              className={classes.control}
            >
              Features
            </Button>
          </Link>
          <Button
            variant="gradient"
            gradient={{ from: "#dc3d31", to: "#99180D" }}
            size="lg"
            className={classes.control}
            onClick={() => wizard?.openWizard()}
          >
            <Trans i18nKey="title.buy" />
          </Button>
          <Button
            variant="outline"
            color="#99180D"
            size="lg"
            leftSection={<IconWand size={18} />}
            className={classes.control}
            onClick={() => wizard?.openWizard()}
          >
            <Trans i18nKey="wizard.cta" />
          </Button>
        </Group>
      </div>

      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
      <Space h="xl" />
    </Container>
  );
}
